import React from 'react';
import { Navigate } from 'react-router-dom';

const parseJwt = (token: any) => {
    try {
        return JSON.parse(atob(token.split('.')[1].replace(/_/g, '/').replace(/-/g, '+')));
    } catch {
        // A missing or malformed token is the normal logged-out case, not an error.
        return null;
    }
};

const ProtectedRoute = ({ children }: any) => {
    // check if the token is in the url
    // this is needed by app login
    const bear_token = (window as any).bear_token;
    if (bear_token) {
        localStorage.setItem('token', bear_token);
        (window as any).bear_token = undefined;
    }

    function hasJWT() {
        let flag = false;

        const token = localStorage.getItem('token');
        const decoded = parseJwt(token);
        if (decoded && decoded.exp * 1000 > Date.now()) {
            flag = true;
        }
        return flag;
    }

    if (!hasJWT()) {
        return <Navigate to='/login' />;
    }

    return children;
};

export default ProtectedRoute;
